import { useState, useEffect } from "react";
import Header from "../../../componente/header";
import "./style.css";
import api from "../../../services/api";
import Modal from "react-modal";
import PopUp from "../../../componente/popup";
import PopUpMotivoExclusao from "../../../componente/popup";
import { podeInserir, podeEditar, podeExcluir } from "../../../componente/permissoes";

function CadGrupoProduto(){
  
  const [lista, setlista] = useState([]);
  const [abusca, setabusca] = useState("");
  const [showform, setshowform] = useState(false);

  const [edtcodgrupo, setedtcodgrupo] = useState(0);
  const [edtdescricao, setedtdescricao] = useState("");    
  const [edtativo, setedtativo] = useState("");

  const [novo, setnovo] = useState(false);  

  const [isOpen, setIsOpen] = useState(false);
  const [isOpenMotivoExclusao, setIsOpenMotivoExclusao] = useState(false);
  const [edtMotivo, setEdtMotivo] = useState("");

  const handleOpen = (cad) => {
    setedtcodgrupo(cad.codgrupo);
    setIsOpen(true);
  };

  const handleConfirma = () => {
    setIsOpen(false);
    setEdtMotivo("");
    setIsOpenMotivoExclusao(true);
  };

  const handleInformarMotivoExclusao = () => {
    if (edtMotivo !== "") {
      Excluir();
      setIsOpenMotivoExclusao(false);
      ListarGrupo();
    } else {
      alert("Descreva o motivo antes de informar");
    }
  };

  const handleCloseMotivoExclusao = () => {
    setIsOpenMotivoExclusao(false);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  function ListarGrupo() {
    api
      .get("v1/cadastro/grupoproduto", {
        params: {
          busca: abusca,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(function (response) {
        setlista(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Cadastrar() {
    api
      .post(
        "v1/cadastro/grupoproduto",
        {
          descricao: edtdescricao,
          ativo: edtativo,
          codusuario: localStorage.getItem("tempCodUsuario"),
          excluido: "N",
          codempresa: 1,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        }
      )
      .then(() => {
        setabusca("a");
        setabusca("");
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Editar() {
    api
      .put(
        "v1/cadastro/grupoproduto",
        {
          codgrupo: edtcodgrupo,
          descricao: edtdescricao,
          codusuario: localStorage.getItem("tempCodUsuario"),    
          ativo: edtativo,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        }
      )
      .then(() => {
        ListarGrupo();        
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Excluir() {
    api
      .delete("v1/cadastro/grupoproduto", {
        params: {
          codgrupo: edtcodgrupo,
          motivo: edtMotivo,
          codusuario: localStorage.getItem("tempCodUsuario")
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(() => {
        ListarGrupo();        
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Salvar() {
    novo ? Cadastrar() : Editar();
    setshowform(false);
  }

  useEffect(() => {
    ListarGrupo();
  }, [abusca, showform, handleConfirma]);

  function closeModal() {
    setshowform(false);
  }

  function openModalNovo() {
    setshowform(true);
    setnovo(true);

    setedtcodgrupo(0);
    setedtdescricao("");        
    setedtativo("S");
  }

  function openModalEditar(props) {
    setshowform(true);
    setnovo(false);

    setedtcodgrupo(props.codgrupo);
    setedtdescricao(props.descricao);        
    setedtativo(props.ativo);
  }  

  return (
    <>
      <Header />
      <div className="container-fluid">
        <div>
        <div>
            <PopUp isOpen={isOpen} onClose={handleClose}>
              <h2>Verificação</h2>
              <p>Tem certeza que deseja excluir esse registro?</p>

              <div className="row">
                <div className="col-12 mt-3 d-flex justify-content-end">
                  <button
                    className="btn btn-primary me-2"
                    onClick={handleConfirma}
                  >
                    Sim
                  </button>
                  <button className="btn btn-danger" onClick={handleClose}>
                    Não
                  </button>
                </div>
              </div>
            </PopUp>
          </div>

          <div>
            <PopUpMotivoExclusao isOpen={isOpenMotivoExclusao} onClose={handleCloseMotivoExclusao}>
              <h2>Antes de Excluir</h2>
              <p>Informe qual o motivo da exclusão?</p>

              <div className="col-sm-12">
                <label htmlFor="motivo" className="form-label">
                  Motivo
                </label>
                <input
                  type="text"
                  id="motivo"
                  className="form-control"
                  placeholder="Descreva aqui"
                  value={edtMotivo}
                  onChange={(e) => setEdtMotivo(e.target.value)}
                />
              </div>

              <div className="row">
                <div className="col-12 mt-3 d-flex justify-content-end">
                  <button
                    className="btn btn-primary me-2"
                    onClick={handleInformarMotivoExclusao}
                  >
                    Informar
                  </button>
                  <button className="btn btn-danger" onClick={handleCloseMotivoExclusao}>
                    Cancelar
                  </button>
                </div>
              </div>
            </PopUpMotivoExclusao>
          </div>

          <Modal
            isOpen={showform}
            onRequestClose={closeModal}
            overlayClassName="modal-overlay"
            className="modal-content modal-xl"
          >
            <div className="container-fluid h-100">
              <div className="modal-header">
                {novo ? <h2>Novo Cadastro</h2> : <h2>Editando Cadastro</h2>}
              </div>              

              <div className="modal-body">
                <form>
                  <div className="row col-sm-12">
                    <div className="col-sm-10">
                      <label htmlFor="descricao" className="form-label">
                        Descrição
                      </label>
                      <input
                        type="text"
                        id="descricao"
                        className="form-control"
                        placeholder="Descrição"
                        value={edtdescricao}
                        onChange={(e) => setedtdescricao(e.target.value)}
                      />
                    </div>                    
                  </div>

                  <div className="row col-sm-12">                   
                    <div className="col-sm-4">
                      <div>
                        <label htmlFor="ativo1" className="form-label">
                          Ativo
                        </label>
                        <br />
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="ativo"
                            value="S"
                            onChange={(e) => setedtativo(e.target.value)}
                            checked={edtativo === "S"}
                          />
                          <label
                            className="form-check-label"
                            for="inlineRadio1"
                          >
                            Sim
                          </label>
                        </div>

                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="ativo"
                            value="N"
                            onChange={(e) => setedtativo(e.target.value)}
                            checked={edtativo === "N"}
                          />
                          <label className="form-check-label">Não</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <div className="modal-footer">
                <div className="col-12 mt-3 d-flex justify-content-end">
                  <button className="btn btn-danger ms-4" onClick={closeModal}>
                    Cancelar
                  </button>
                  <button className="btn btn-success ms-4" onClick={Salvar}>
                    Salvar
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        </div>

        <div className="row">
          <h1 className="ms-4">Cadastro de Grupo de Produto</h1>
          <p className="ms-4">
            Rotina para cadastrar todos os grupos dos produtos.
          </p>
          <hr />
        </div>

        <div className="row">
          <div className="col-10">
            <label className="d-block" htmlFor="busca">
              Busque aqui
            </label>
            <input
              type="text"
              placeholder="Buscar por: Código ou descrição"
              name="busca"
              id="busca"
              className="form-control me-3"
              value={abusca}
              onChange={(e) => setabusca(e.target.value)}
            />
          </div>
          <div className="col-2 d-flex justify-content-center">
            <button
              className="btn btn-success btnnovo"
              onClick={() => openModalNovo()}
              disabled={!podeInserir("/cadastro/grupoproduto")}
            >
              Novo
            </button>
          </div>
        </div>

        <div className="row mt-3">
          <hr />
        </div>

        <div className="row tabela">
          <table className="table table-hover">
            <thead>
              <tr>
                <th className="codigo">Código</th>
                <th className="razao">Descrição</th>            
                <th className="acao">Ações</th>
              </tr>
            </thead>
            <tbody>
              {lista.map(function (item) {
                return (
                  <tr key={item.codgrupo}>
                    <th>{item.codgrupo}</th>
                    <th>{item.descricao}</th>                    
                    <th>
                      <div className="d-flex justify-content-center">
                        <button
                          className="btn fa-regular fa-pen-to-square"
                          onClick={() => openModalEditar(item)}
                          disabled={!podeEditar("/cadastro/grupoproduto")}
                        ></button>
                        <button
                          className="btn fa-solid fa-trash"
                          onClick={() => handleOpen(item)}
                          disabled={!podeExcluir("/cadastro/grupoproduto")}
                        ></button>
                      </div>
                    </th>
                  </tr>
                );
              })}
            </tbody>
            <tfoot>
              <tr>
                <th colSpan={5}>Quantidade de Registros: {lista.length}</th>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </>
  );
}

export default CadGrupoProduto;